<template>
  <div>
    <div v-if="userData && userData._id">
      <!-- gala templates -->
      <light-character-card
        isWidget="true"
        v-if="userData.resumeTemplate === 'lightcharactercard'"
      />
      <dark-character-card
        isWidget="true"
        v-else-if="userData.resumeTemplate === 'darkcharactercard'"
      />
      <grey-line
        isWidget="true"
        v-else-if="userData.resumeTemplate === 'greyline'"
        class="resume-preview"
      />
      <prestige isWidget="true" v-else class="resume-preview" />
    </div>
  </div>
</template>

<script>
import organizationConfig from "@/assets/data/organization-config.js";
import GreyLine from "@/layouts/components/editor/templates/GreyLine/GreyLine.vue";
import Prestige from "@/layouts/components/editor/templates/Prestige/Prestige.vue";
import LightCharacterCard from "@/layouts/components/editor/templates/Gala/LightCharacterCard.vue";
import DarkCharacterCard from "@/layouts/components/editor/templates/Gala/DarkCharacterCard.vue";

export default {
  components: { GreyLine, Prestige, LightCharacterCard, DarkCharacterCard },
  data() {
    return {
      loggedInUserIsValid: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    boardSlug() {
      return this.$route.params.boardSlug;
    },
    boardUserId() {
      return this.$route.params.boardUserId;
    },
    loggedInUser() {
      return this.$store.state.auth.user;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },
};
</script>
